import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.5 19C3.462 16.056 3.462 7.7 3.462 7.7m0 0V5.298c0-1.033.839-1.87 1.866-1.862h12.97c1.028 0 1.866.837 1.866 1.862V7.7H3.462M7.687 3.395V2M16.096 3.272V2"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8 16.786v2.129c.026.333.281.595.639.643 1.865.215 7.536 1 8.533-.739.872-2.033-3.27-3.225-1.917 2.891l.026.43c.026.404.537.571.843.309l5.723-5.528a.44.44 0 0 0 0-.667L16.2 10.798c-.307-.286-.843-.072-.843.333l.025 1.716c0 .238-.204.429-.46.429l-1.021-.024"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const NextDayIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
